// extracted by mini-css-extract-plugin
export var addressFields = "_lt-0";
export var animationContainer = "_lt-1";
export var footer = "_lt-2";
export var lineItems = "_lt-3";
export var modalContent = "_lt-4";
export var orderName = "_lt-5";
export var strong = "_lt-6";
export var warning = "_lt-7";